<template>
	<div class="report_container full" v-loading="loading">
		<el-container class="full">
			<el-main class="main" style="position: relative;">
				<vxe-grid ref="relationswarehouseList" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</el-main>
		</el-container>
		<jindieextra ref="relationwarehousejindieextra" :type="jindieextratype" @submit="jindieSubmit" />
		<wlnwarehouse ref="relationwarehousewlnwarehouse" @submit="wlnwarehouseSubmit" />
	</div>
</template>
<style>

</style>
<style scoped>
	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}
	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}
	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;
	}
	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import jindieextra from './box/jindieextra'
	import wlnwarehouse from './box/wlnwarehouse'
	export default {
		mixins: [listMixins],
		name: 'report',
		props: {
			fundtype: {
				default: () => {
					return 'CD'
				}
			},
			bancktype: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				loading: false,
				currentrow:null,
				currentcolumn:null,
				jindieextratype: [],
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},
		methods: {
			getgrid(){
				return this.$refs.relationswarehouseList
			},
			add(){
				this.getgrid().insert({})
			},
			delete(row){
				this.getgrid().remove(row)
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.height = "auto"
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '新增',
						status: 'primary',
						code: 'add'
					},{
						name: '保存',
						status: 'success',
						code: 'submit'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.columns = [{
						field: 'wln_id',
						title: '万里牛ID',
						fixed:"left",
						editRender: {
							name: '$input',
							props: {
								readonly: true
							},
							events: {

							}
						},
					},{
						field: 'wln_name',
						title: '万里牛名称',
						fixed:"left",
						editRender: {
							name: '$inputButton',
							props: {
								quote: false
							},
							events: {
								inputButtonclick:(e)=>{
									// console.log(e)
									this.currentrow = e.row
									this.currentcolumn = e.column.field
									this.$refs.relationwarehousewlnwarehouse.initList()
									this.$refs.relationwarehousewlnwarehouse.box.alertBox()
								}
							}
						},	
					}, {
						field: 'jindie_warehousecode',
						title: '[星空]仓库编码',
						editRender: {
							name: '$inputButton',
							props: {
								quote: false
							},
							events: {
								inputButtonclick:(e)=>{
									// console.log(e)
									this.currentrow = e.row
									this.currentcolumn = e.column.field
									this.jindieextratype = ['BD_STOCK']
									this.$refs.relationwarehousejindieextra.initList()
									this.$refs.relationwarehousejindieextra.box.alertBox()
								}
							}
						},			
					}, 
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button style="color:#F56C6C;" type = "text" size = "mini" onClick = {() => {this.delete(row)}}>删除</el-button>]
							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.editRules = {
					wln_id: [{
						required: true
					}],
					jindie_warehousecode: [{
						required: true
					}]
				}
			},
			jindieSubmit(e){				
				if (e.data) {
					this.currentrow[this.currentcolumn] = e.data.FNumber
				} else {
					this.currentrow[this.currentcolumn] = null
				}
			},
			wlnwarehouseSubmit(e){
				if (e.data) {
					this.currentrow.wln_id = e.data.storageUid
					this.currentrow.wln_name = e.data.storageName
				} else {
					this.currentrow.wln_id = null
					this.currentrow.wln_name = null
				}
			},
			customreload() {
				this.getgrid().commitProxy('query')
			},
			list() {
				return new Promise((resolve) => {
					this.$api.platformmap.list({
						fromdatatype:'warehouse',
						fromplant:'wln',
						toplant:'jindie',
					}).then((res) => {
						res.list = res.list.map((item)=>{
							return {...item,...item.fromdata,...item.todata}
						})
						resolve(res)
					}, () => {
						resolve()
					})
				})
			},
			submit(){
				this.getgrid().validate(true, (res) => {
					if (!res) {
						let detail = this.getgrid().getTableData().visibleData
						let data = []
						detail.forEach((item)=>{
							data.push({
								fromdataid:item.wln_id,
								fromdatatype:'warehouse',
								fromplant:'wln',
								fromdata:{
									wln_id: item.wln_id,
									wln_name: item.wln_name,
								},
								toplant:'jindie',
								todata:{
									jindie_warehousecode:item.jindie_warehousecode
								}
							})
						})
						this.loading = true
						this.$api.platformmap.batchsave({
								data:data,
								fromdatatype:'warehouse',
								fromplant:'wln',
								toplant:'jindie',
							}).then(() => {
							this.loading = false
							this.$message.success('操作成功')
							this.customreload()
						}, () => {
							this.loading = false
						})
					} else {
						for (let i in res) {
							console.log(res[i][0].rule)
							let content = res[i][0].rule.$options.content
							let message = res[i][0].rule.$options.message
							if(content){
								this.$message.error(content)
							}else if(message){
								this.$message.error(message)
							}else{
								this.$message.error('缺少必填项：' + res[i][0].column.title)
							}
							
						}
					}
				})
			}
		},
		components: {
			jindieextra,
			wlnwarehouse
		}
	}
</script>